import axios from 'axios'
export const getAllClient = (params) => {
  return axios.get('clients', {
    params: params
  })
}



// WEBPACK FOOTER //
// ./src/api/client.js